import React, { Component } from 'react';
import Helmet from 'react-helmet';

import ScrollContainer from '@components/ScrollContainer/ScrollContainer';
import List from './List/List';

import ImagePanel from '@components/ImagePanel/ImagePanel';
import CloudPanel from '@components/CloudPanel/CloudPanel.jsx';
import TextBox from '@components/TextBox/TextBox';
import PlaneInfo from './PlaneInfo/PlaneInfo';
import PlaneDetails from './PlaneDetails/PlaneDetails';
import { Container, Col, Row } from 'reactstrap';
import P100Details from './P100Details';
import P300Details from './P300Details';
//import L650Details from './L650Details';
import ImportImages from '@src/importImages';

const Image = ImportImages('/ouraircraft/slider.jpg');

class OurAircraft extends Component {
  constructor(props) {
    super(props);

    let title = 'Aircraft | JetSuite';
    let description =
      'From our four-passenger Embraer Phenom 100s, to our seven-passenger Phenom 300s, and our 13-seat Legacy' +
      ' 650, the JetSuite fleet offers a range of luxury options to fit every travel need, all outfitted with' +
      ' state-of-the-art interiors and Wifi connectivity.';

    let planeDetails = {};
    let autoScroll = 1;
    if (window.location.pathname === '/our-aircraft/p100') {
      planeDetails = P100Details;
      autoScroll = 2;
      title = 'Aircraft | P100 | JetSuite';
      description = P100Details.content;
    } else if (window.location.pathname === '/our-aircraft/p300') {
      planeDetails = P300Details;
      autoScroll = 2;
      title = 'Aircraft | P300 | JetSuite';
      description = P300Details.content;
      /*} else if (window.location.pathname === '/our-aircraft/l650') {
      planeDetails = L650Details;
      autoScroll = 2;
      title = 'Aircraft | L650 | JetSuite';
      description = L650Details.content;*/
    } else {
      planeDetails = P100Details;
    }

    this.state = {
      ...planeDetails,
      activeBox: 'plane-overview',
      autoScroll: autoScroll,
      hash: window.location.pathname,
      title: title,
      description: description
    };
  }

  componentDidUpdate(prevProps, prevState) {
    // Typical usage (don't forget to compare props):
    if (window.location.pathname !== this.state.hash) {
      let planeDetails = {};
      let autoScroll = 1;

      let title = 'Aircraft | JetSuite';
      let description =
        'From our four-passenger Embraer Phenom 100s, to our seven-passenger Phenom 300s, and our 13-seat Legacy' +
        ' 650, the JetSuite fleet offers a range of luxury options to fit every travel need, all outfitted with' +
        ' state-of-the-art interiors and Wifi connectivity.';
      if (window.location.pathname === '/our-aircraft/p100') {
        planeDetails = P100Details;
        autoScroll = 2;
        title = 'Aircraft | P100 | JetSuite';
        description = P100Details.content;
      } else if (window.location.pathname === '/our-aircraft/p300') {
        planeDetails = P300Details;
        autoScroll = 2;
        title = 'Aircraft | P300 | JetSuite';
        description = P300Details.content;
        /*} else if (window.location.pathname === '/our-aircraft/l650') {
        planeDetails = L650Details;
        autoScroll = 2;
        title = 'Aircraft | L650 | JetSuite';
        description = L650Details.content;*/
      } else {
        planeDetails = P100Details;
      }
      this.setState({
        ...planeDetails,
        activeBox: 'plane-overview',
        autoScroll: autoScroll,
        hash: window.location.pathname,
        title: title,
        description: description
      });
    }
  }

  onDetailClick = action => {
    this.setState({
      activeBox: action
    });
  };

  onListClick = plane => {
    let planeDetails = {};
    if (plane === 'P100') {
      planeDetails = P100Details;
    } else if (plane === 'P300') {
      planeDetails = P300Details;
    } else {
      planeDetails = P100Details;
    }
    this.setState({
      ...planeDetails,
      activeBox: 'plane-overview',
      activeMobileBox: plane,
      autoScroll: 2
    });

    if (this.props.pageWidth > 991) {
      const event = new CustomEvent('goto', {
        detail: {
          pageNo: 2
        }
      });
      window.dispatchEvent(event);
    }
  };

  render() {
    const containerProps = {
      pageHeight: this.props.pageHeight
    };
    containerProps.autoScroll = {
      active: this.state.autoScroll,
      delay: 1000
    };

    let classNames = '';
    if (window.innerWidth < 992) {
      classNames = 'pt-6 pb-4';
    } else {
      classNames = 'abs-container d-flex align-items-center';
    }

    const compareProps = {
      header: 'Compare',
      content: 'Compare this aircraft with another in our fleet.',
      link: {
        url: '/compare-aircraft',
        label: 'Compare Aircraft',
        classNames: 'btn btn-default mt-3'
      }
    };

    const content = [];
    content.push(
      <List
        key={'our-aircraft-list'}
        id={'our-aircraft-list'}
        heightSm={this.props.heightSm}
        {...this.props}
        {...this.state}
        click={plane => this.onListClick(plane)}
        planesData={{
          p100: P100Details,
          p300: P300Details
          //l650: L650Details
        }}
      />
    );
    if (this.props.pageWidth > 991) {
      content.push(
        <PlaneInfo
          key={'our-aircraft-plane'}
          {...this.state}
          screenHeight={this.props.pageHeight}
        />
      );
      content.push(
        <PlaneDetails
          key={'our-aircraft-details'}
          heightSm={this.props.heightSm}
          {...this.state}
          screenHeight={this.props.pageHeight}
          click={activeBox => this.onDetailClick(activeBox)}
        />
      );
    }

    return (
      <React.Fragment>
        <Helmet>
          <title>{this.state.title}</title>
          <meta name="description" content={this.state.description} />
        </Helmet>
        <ScrollContainer {...containerProps}>
          <ImagePanel
            id={'our-aircraft-imagepanel'}
            screenHeight={this.props.pageHeight}
            image={Image}
            alt={'Compare Aircraft'}
          />

          {content}

          <CloudPanel
            id={'our-aircraft-compare'}
            screenHeight={this.props.pageHeight}
          >
            <Container fluid={true} className={classNames}>
              <Row className={'w-100 mx-auto'}>
                <Col xs={12} md={{ offset: 5, size: 6 }}>
                  <TextBox {...compareProps} />
                </Col>
              </Row>
            </Container>
          </CloudPanel>
        </ScrollContainer>
      </React.Fragment>
    );
  }
}

export default OurAircraft;



// WEBPACK FOOTER //
// ./src/components/OurAircraft/OurAircraft.jsx